/* eslint-disable no-mixed-spaces-and-tabs */
/* eslint-disable react/jsx-wrap-multilines */
import React, { useEffect } from 'react';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { reset, submit } from 'redux-form';
import { useHistory, useLocation } from 'react-router';
import PropTypes from 'prop-types';
import { useInjectSaga } from '../../utils/injectSaga';
import saga from './saga';
import { useInjectReducer } from '../../utils/injectReducer';
import reducer from './reducer';
import { ModalWindow } from '../../semantic-ui/components/modal-window';
import ModalFooterButtons from '../../semantic-ui/components/modal-window/modal-footer-buttons';
import {
	createIcepackAction,
	getPartnersAction,
	getIcepackInfoAction,
	updateIcepackAction,
	resetIcepackModalAction,
	deleteIcepackAction,
} from './actions';
import {
	getIsModalShownSelector,
	getIsIcepackAddFormOpenSelector,
	getIsIcepackEditFormOpenSelector,
	getIsIcepackCreatingSelector,
	getIsIcepackUpdatingSelector,
	getActiveIcepackIdSelector,
	getIsAuditTabShownSelector,
	getIcepackInfoSelector,
	getIsIcepackInfoLoadingSelector,
	getIcepackNameSelector,
	getIsIcepackDeletingSelector,
} from './selectors';
import { ICEPACK_FORM_NAME } from './constants';
import { IcepackModalContent } from './components/icepack-modal-content';
import { Audit } from '../../components/audit';
import { getIsAvailableIcepacksButtonsSelector } from '../profile/selectors';
import closeModal from '../../utils/closeModal';
import { setWindowInfoAction } from '../alert-modal/actions';
import { removeModalQuery } from '../../utils/removeModalQuery';

const IcepackModalWrapper = ({
	isAvailable,
	isModalShown,
	isIcepackAddFormOpen,
	isIcepackEditFormOpen,
	isIcepackCreating,
	isIcepackUpdating,
	isIcepackDeleting,
	activeIcepackId,
	isAuditTabShown,
	isIcepackInfoLoading,
	icepackInfo,
	icepackName,
	onFormSubmit,
	onClearForm,
	onResetState,
	onGetPartners,
	onCreateIcepack,
	onUpdateIcepack,
	onDeleteIcepack,
	onGetIcepackInfo,
	onSetWindowInfo,
}) => {
	if (!isModalShown) return null;
	useInjectSaga({ key: 'icepackModalSaga', saga });
	useInjectReducer({ key: 'icepackModalReducer', reducer });

	const { search, pathname } = useLocation();

	const query = new URLSearchParams(search);

	const modal = query.get('modal');

	const mode = query.get('mode');

	const history = useHistory();

	useEffect(() => {
		if (isIcepackAddFormOpen || isIcepackEditFormOpen) {
			onGetPartners();
		}
	}, [isIcepackAddFormOpen, isIcepackEditFormOpen]);

	useEffect(() => {
		if (activeIcepackId) {
			onGetIcepackInfo(activeIcepackId);
		}
	}, [activeIcepackId]);

	const handleModalClose = () => {
		closeModal(query);

		onClearForm();
		onResetState();

		history.push(`${pathname}?${query}`);
	};

	const handleNavItemClick = target => {
		if (target === 'audit') {
			query.set('tab', 'audit');
		} else {
			query.set('modal', target);
			query.delete('tab');
		}

		if (mode) {
			query.delete('mode');
		}

		history.push(`${pathname}?${query}`);
	};

	const handleIcepackFormOpenButtonClick = mode => {
		if (activeIcepackId) {
			query.set('id', activeIcepackId);
		} else {
			query.delete('id');
		}

		if (mode === 'edit') {
			query.set('mode', 'edit');
		}

		if (mode === 'cancel') {
			onClearForm();
			query.delete('mode');
		}

		if (mode === 'cancel' && !activeIcepackId) {
			onResetState();
			query.delete('modal');
		}

		history.push(`${pathname}?${query}`);
	};

	const handleIcepackFormSubmit = async () => {
		await onFormSubmit(ICEPACK_FORM_NAME);

		if (activeIcepackId) {
			onUpdateIcepack({
				id: activeIcepackId,
				searchQuery: removeModalQuery(query.toString()),
				redirect: () => handleIcepackFormOpenButtonClick('cancel'),
			});

			return;
		}

		onCreateIcepack({
			redirect: handleModalClose,
			searchQuery: removeModalQuery(query.toString()),
		});
	};

	const handleKeyDown = e => {
		if (e.key === 'Enter' && e.shiftKey === false) {
			handleIcepackFormSubmit();
		}
	};

	const handleIcepackDelete = () => {
		onSetWindowInfo({
			type: 'delete',
			title: 'Вы уверены?',
			text: 'Вы не сможете это отменить',
			button: {
				type: 'success',
				text: 'Да, удалить',
				onClick: () =>
					onDeleteIcepack({
						id: activeIcepackId,
						redirect: handleModalClose,
						searchQuery: removeModalQuery(query.toString()),
					}),
			},
		});
	};

	return (
		<ModalWindow
			isLoading={isIcepackInfoLoading}
			isModalShown={isModalShown}
			onKeyDown={handleKeyDown}
			onClose={handleModalClose}
			navItems={
				isIcepackAddFormOpen || isIcepackEditFormOpen
					? []
					: [
							{
								id: 'info',
								text: 'Информация',
								onClick: () => handleNavItemClick('icepack'),
								isActive: modal === 'icepack' && !isAuditTabShown,
							},
							{
								id: 'audit',
								text: 'Изменения',
								onClick: () => handleNavItemClick('audit'),
								isActive: isAuditTabShown,
							},
					  ]
			}
			headerText={
				isIcepackAddFormOpen || isIcepackEditFormOpen
					? `${isIcepackEditFormOpen ? 'Изменить хладоэлемент' : 'Создать хладоэлемент'}`
					: icepackName
			}
			modalContent={
				!isAuditTabShown ? (
					<IcepackModalContent
						isLoading={isIcepackInfoLoading}
						icepackInfo={icepackInfo}
						isIcepackFormOpen={isIcepackAddFormOpen || isIcepackEditFormOpen}
					/>
				) : (
					<Audit entityName="icepacks" entityId={activeIcepackId} />
				)
			}
			style={{ width: '895px' }}
			actionButtons={[{ type: 'close', onClick: handleModalClose, text: 'profile' }]}
			footerButtons={
				<ModalFooterButtons
					leftButtons={
						!(isIcepackAddFormOpen || isIcepackEditFormOpen) && isAvailable.delete && !isAuditTabShown
							? [
									{
										onClick: handleIcepackDelete,
										text: 'Удалить',
										color: 'warning',
										disabled: isIcepackInfoLoading || isIcepackDeleting,
									},
							  ]
							: []
					}
					rightButtons={
						isIcepackAddFormOpen || isIcepackEditFormOpen
							? [
									{
										onClick: handleIcepackFormSubmit,
										text: 'Сохранить',
										color: 'primary',
										loading: isIcepackCreating || isIcepackUpdating,
										disabled: isIcepackInfoLoading || isIcepackCreating || isIcepackUpdating,
									},
									{
										onClick: () => handleIcepackFormOpenButtonClick('cancel'),
										text: 'Отмена',
										color: 'secondary',
										disabled: isIcepackCreating || isIcepackUpdating,
									},
							  ]
							: [
									...(isAvailable.update && !isAuditTabShown
										? [
												{
													onClick: () => handleIcepackFormOpenButtonClick('edit'),
													text: 'Изменить',
													color: 'primary',
													disabled: isIcepackInfoLoading || isIcepackDeleting,
												},
										  ]
										: []),
									{
										onClick: handleModalClose,
										text: 'Закрыть',
										color: 'secondary',
									},
							  ]
					}
				/>
			}
		/>
	);
};

const mapStateToProps = createStructuredSelector({
	isAvailable: getIsAvailableIcepacksButtonsSelector(),
	isModalShown: getIsModalShownSelector(),
	isIcepackAddFormOpen: getIsIcepackAddFormOpenSelector(),
	isIcepackEditFormOpen: getIsIcepackEditFormOpenSelector(),
	isIcepackCreating: getIsIcepackCreatingSelector(),
	isIcepackUpdating: getIsIcepackUpdatingSelector(),
	isIcepackDeleting: getIsIcepackDeletingSelector(),
	activeIcepackId: getActiveIcepackIdSelector(),
	isAuditTabShown: getIsAuditTabShownSelector(),
	isIcepackInfoLoading: getIsIcepackInfoLoadingSelector(),
	icepackInfo: getIcepackInfoSelector(),
	icepackName: getIcepackNameSelector(),
});

const mapDispatchToProps = {
	onFormSubmit: submit,
	onClearForm: () => reset(ICEPACK_FORM_NAME),
	onResetState: resetIcepackModalAction,
	onGetPartners: getPartnersAction,
	onCreateIcepack: createIcepackAction,
	onUpdateIcepack: updateIcepackAction,
	onDeleteIcepack: deleteIcepackAction,
	onGetIcepackInfo: getIcepackInfoAction,
	onSetWindowInfo: setWindowInfoAction,
};

IcepackModalWrapper.propTypes = {
	isAvailable: PropTypes.objectOf(PropTypes.bool),
	isModalShown: PropTypes.bool.isRequired,
	isIcepackAddFormOpen: PropTypes.bool.isRequired,
	isIcepackEditFormOpen: PropTypes.bool.isRequired,
	isIcepackCreating: PropTypes.bool.isRequired,
	isIcepackUpdating: PropTypes.bool.isRequired,
	isIcepackDeleting: PropTypes.bool.isRequired,
	activeIcepackId: PropTypes.string,
	isAuditTabShown: PropTypes.bool.isRequired,
	isIcepackInfoLoading: PropTypes.bool.isRequired,
	icepackInfo: PropTypes.arrayOf(
		PropTypes.shape({
			id: PropTypes.string.isRequired,
			title: PropTypes.string.isRequired,
			value: PropTypes.oneOfType([
				PropTypes.string,
				PropTypes.shape({
					name: PropTypes.string,
					role: PropTypes.string,
				}),
				PropTypes.shape({
					length: PropTypes.string,
					width: PropTypes.string,
					height: PropTypes.string,
				}),
			]).isRequired,
		}),
	),
	icepackName: PropTypes.string.isRequired,
	onFormSubmit: PropTypes.func.isRequired,
	onClearForm: PropTypes.func.isRequired,
	onResetState: PropTypes.func.isRequired,
	onGetPartners: PropTypes.func.isRequired,
	onCreateIcepack: PropTypes.func.isRequired,
	onUpdateIcepack: PropTypes.func.isRequired,
	onDeleteIcepack: PropTypes.func.isRequired,
	onGetIcepackInfo: PropTypes.func.isRequired,
	onSetWindowInfo: PropTypes.func.isRequired,
};

const IcepackModal = connect(mapStateToProps, mapDispatchToProps)(IcepackModalWrapper);

export default IcepackModal;
